import { render, staticRenderFns } from "./worksdetail.vue?vue&type=template&id=678e62a0&"
import script from "./worksdetail.vue?vue&type=script&lang=js&"
export * from "./worksdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports